import { JSX, useState } from "react";
import { useTranslation } from "react-i18next";

import Button from "@/components/buttons/Button.tsx";
import CommentDetailModal from "@/components/cards/CommentCard/Modal.tsx";
import { IconStar } from "@/components/icons";

import { cn } from "@/utils/cn";

interface CommentCardProps {
  isFull: boolean;
  text: string;
  rating: number;
  time: string;
  user: string;
}

const CommentCard = ({ isFull = false, text, rating = 0, time, user }: CommentCardProps): JSX.Element => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const formattedDate = new Date(time).toLocaleDateString("ru", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return (
    <div
      className={
        "flex h-full w-full flex-1 flex-col rounded-2xl px-8 py-6 outline outline-1 -outline-offset-1 outline-grey-1 transition-colors hover:bg-[#ffffff1a] max-md:p-3"
      }
    >
      <div className={"flex flex-row flex-wrap items-start justify-between gap-3"}>
        <div className="overflow-hidden">
          <h3 className={"text-wrap text-2xl/7 font-semibold max-md:text-base/tight"}>{user}</h3>
          <p className={"mt-3 text-lg/5 text-grey-1 max-md:mt-1.5 max-md:text-sm/tight"}>{formattedDate}</p>
        </div>
        {rating != null && rating > 0 && (
          <span
            className={"flex items-center gap-1.5 text-[2rem]/tight font-semibold text-[#FFB800] max-lg:text-2xl/tight"}
          >
            <IconStar className={"size-6 fill-[#FFB800]"} />
            {rating}
          </span>
        )}
      </div>
      <p
        className={cn("mt-5 h-full", {
          "line-clamp-6": !isFull,
        })}
      >
        {text}
      </p>
      {!isFull ? (
        <>
          <Button
            size={"medium"}
            onClick={() => setIsModalOpen(true)}
            className={"mt-5 !w-fit self-end px-4 py-2 max-md:mt-4 max-md:px-3"}
          >
            {t("Actions.read-all")}
          </Button>
          <CommentDetailModal
            isOpen={isModalOpen}
            setIsOpen={setIsModalOpen}
            isFull={true}
            text={text}
            rating={rating}
            time={time}
            user={user}
          />
        </>
      ) : null}
    </div>
  );
};

export default CommentCard;
